<h3 class="text-center text-light bg-secondary border">{{loadStatus}} ({{loads.length}})</h3>
<div class="row">
    <div [ngClass]="'p-0 col-lg-' + cardSize" *ngFor="let load of loads">
        <div class="standard-card {{getCardClass(load)}}">
            <h3>Order #<a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{load.legNumber}}</a></h3>
            <div (click)="loadClick(load)">
                <div class="row">
                    <div class="col-lg-6">
                        <strong>O:</strong> {{load.originCityST}}<br />
                        <strong>D:</strong> {{load.destinationCityST}}
                    </div>
                    <div class="col-lg-6">
                        <div><i class="fas fa-dollar-sign fa-lg" style="width:2.0rem;"></i> {{load.customerCode}}</div>
                        <div *ngIf="load.carrierCode!=''"><i class="fas fa-truck-moving fa-lg" style="width:2.0rem;"></i> {{load.carrierCode}}</div>
                    </div>
                </div>
                <div class="row" *ngIf="load.firstPickupDate!=''">
                    <div class="col-lg-12">
                        <strong>Start:</strong>
                        {{load.firstPickupDate | date: 'M/dd/yyyy HH:mm'}}
                    </div>
                </div>
                <div class="row" *ngIf="load.nextEvent!=''">
                    <div class="col-lg-12">
                        <strong>Next Evt:</strong>
                        <span><i class="fas fa-circle fa-lg" [ngClass]="{'text-danger': load.minutesUntilDue <= 0, 'text-warning': load.minutesUntilDue > 0 && load.minutesUntilDue <= 15, 'text-primary': load.minutesUntilDue > 15 && load.minutesUntilDue <= 30, 'text-success': load.minutesUntilDue > 30}"></i></span>
                        {{load.nextEvent}} {{load.orderEventDate | date: 'M/dd/yyyy HH:mm'}}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                            <tagtype-tag [tag]="tag"></tagtype-tag>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <strong>Ref #s:</strong>
                        {{load.referenceNumbers}}
                    </div>
                </div>
            </div>
            <!--<ul>
        <li><strong>O:</strong> {{load.originCityST}}</li>
        <li><strong>D:</strong> {{load.destinationCityST}}</li>
        <li *ngIf="load.nextEvent!=''">
            <strong>Next Evt:</strong>
            <span><i class="fas fa-circle fa-lg" [ngClass]="{'text-danger': load.minutesUntilDue <= 0, 'text-warning': load.minutesUntilDue > 0 && load.minutesUntilDue <= 15, 'text-primary': load.minutesUntilDue > 15 && load.minutesUntilDue <= 30, 'text-success': load.minutesUntilDue > 30}"></i></span>
            {{load.nextEvent}} {{load.orderEventDate | date: 'M/dd/yyyy HH:mm'}}
        </li>
    </ul>-->
        </div>
    </div>
</div>
